var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_vm._v("Copyright 2020 © All rights Reserved Consultancy Squad | "),_c('a',{directives:[{name:"hover",rawName:"v-hover"}],attrs:{"href":/privacy-policy/}},[_vm._v("Privacy Policy.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }